import { isAxiosError } from 'axios';
import { Result, err, ok } from 'neverthrow';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore utils is in the parent dir
import axios from '@utils/axios';

import { ApiError } from 'types/api/ApiError';
import captureException from 'utils/captureException';

export async function skipSuggestion(
  suggestionId: number
): Promise<Result<null, ApiError>> {
  try {
    const response = await axios.post(`/suggestions/${suggestionId}`, {
      status: 'rejected',
    });

    return ok(response.data);
  } catch (error) {
    captureException(error, { functionName: 'skipSuggestion' });

    if (!isAxiosError(error)) {
      return err({ message: 'Unable to skip suggestion.' });
    }

    if (error && isAxiosError(error) && error.response?.status === 401) {
      throw error;
    }

    if (error && error.message === 'Extension context invalidated.') {
      throw error;
    }

    return err({
      message: error.response?.data.message || 'Unable to skip suggestion.',
    });
  }
}
